import axios from "axios";
import {
  GET_NOTIFICATION_REQUEST,
  GET_NOTIFICATION_SUCCESS,
  GET_NOTIFICATION_FAIL,
  MARK_NOTIFICATION_REQUEST,
  MARK_NOTIFICATION_SUCCESS,
  MARK_NOTIFICATION_FAIL,
} from "./notificationsTypes";

import { BACK_URI } from "../../config/keys";

export const getNotifications = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_NOTIFICATION_REQUEST });
    const {
      userState: { userInfo },
    } = getState();
    const config = {
      headers: {
        Authorization: userInfo.token,
      },
    };
    const { data } = await axios.get(`${BACK_URI}/notification/${id}`, config);
    dispatch({
      type: GET_NOTIFICATION_SUCCESS,
      payload: data,
    });
    localStorage.setItem("notifications", JSON.stringify(data));
  } catch (error) {
    dispatch({
      type: GET_NOTIFICATION_FAIL,
      payload: error.response && error.response.data.msg ? error.response.data.msg : error.msg,
    });
  }
};

export const updateNotification = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: MARK_NOTIFICATION_REQUEST,
    });

    const {
      userState: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: userInfo.token,
      },
    };
    const { data } = await axios.post(`${BACK_URI}/notification/${id}`, {}, config);
    dispatch({
      type: MARK_NOTIFICATION_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: MARK_NOTIFICATION_FAIL,
      payload: error.response && error.response.data.msg ? error.response.data.msg : error.msg,
    });
  }
};
